import { common } from '../../main/common-sidecar'
import { voyageBackground_hyper } from './voyageBackground_hyper-sidecar'
import { voyageBackground_starfield } from './voyageBackground_starfield-sidecar'

let _enterTimer = 0
let _inTimer = 0
let _exitTimer = 0

let _enterTime = 2
let _inTime = 2
let _exitTime = 2

let _signalStart = false
let _isInHyperspace = false
export const signalHyperspace = () => {
  _signalStart = true
  console.log('Signal hyperspace!!!')
}
export const getIsInHyperspace = () => {
  return _isInHyperspace
}

export function* generator_hyperspace(): Generator<number, number, number> {
  while (true) {
    if (!_signalStart) {
      yield 0
      continue
    }
    _signalStart = false
    _isInHyperspace = true

    voyageBackground_starfield.show(false)
    voyageBackground_hyper.setSpeed(0.001)
    voyageBackground_hyper.reset()

    _enterTimer = 0
    while (true) {
      let ds = common.getUpdateDeltaScaled()
      _enterTimer += ds

      voyageBackground_hyper.setSpeed(_enterTimer / _enterTime)

      // console.log('hyper start', _enterTimer)

      if (_enterTimer >= _enterTime) {
        break
      }

      yield 0
    }

    _inTimer = 0
    while (true) {
      let ds = common.getUpdateDeltaScaled()
      _inTimer += ds

      voyageBackground_hyper.setSpeed(1)

      if (_inTimer >= _inTime) {
        break
      }

      yield 0
    }

    _exitTimer = 0
    while (true) {
      let ds = common.getUpdateDeltaScaled()
      _exitTimer += ds

      voyageBackground_hyper.setSpeed(1 - _exitTimer / _exitTime)

      if (_exitTimer >= _exitTime) {
        break
      }

      yield 0
    }

    voyageBackground_hyper.setSpeed(0)
    _isInHyperspace = false

    voyageBackground_starfield.show(true)
    voyageBackground_starfield.reset()
  }

  return 0
}
